var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { omit } from "lodash";
import { Modal as StandardModal } from "react-bootstrap";
import { connect } from "@irati/store";
import ModalHeader from "./components/ModalHeader";
import { ImageModal, Back, ModalInner, Close } from "./styled";
// onHide is now required by react-bootstrap, send empty func
var DEFAULT_ON_HIDE = function () { };
var CreateModal = function (_a) {
    var onHide = _a.onHide, onExited = _a.onExited, onBack = _a.onBack, image = _a.image, alignImageLeft = _a.alignImageLeft, imageBackgroundColor = _a.imageBackgroundColor, user = _a.user, renderHeader = _a.renderHeader, trophy = _a.trophy, children = _a.children, showClose = _a.showClose, isMobile = _a.isMobile, useMobileStyling = _a.useMobileStyling, props = __rest(_a, ["onHide", "onExited", "onBack", "image", "alignImageLeft", "imageBackgroundColor", "user", "renderHeader", "trophy", "children", "showClose", "isMobile", "useMobileStyling"]);
    var hasCustomHeader = renderHeader !== ModalHeader;
    var hasHeader = image || user || hasCustomHeader;
    var Modal = hasHeader ? ImageModal : StandardModal;
    var size = isMobile && useMobileStyling ? 90 : 150;
    var marginTop = isMobile && useMobileStyling ? 60 : 100;
    return (React.createElement(Modal, __assign({}, omit(props, "dispatch"), { onHide: onHide, onExited: onExited, margintop: marginTop }),
        hasHeader && renderHeader({ image: image, user: user, size: size, alignLeft: alignImageLeft, backgroundColor: imageBackgroundColor }),
        React.createElement(ModalInner, null,
            onBack && React.createElement(Back, { inline: false, icon: "backArrow", onClick: onBack }),
            onHide !== DEFAULT_ON_HIDE && showClose && React.createElement(Close, { inline: false, onClick: onHide }),
            children)));
};
CreateModal.defaultProps = {
    onHide: DEFAULT_ON_HIDE,
    onExited: function () { },
    showClose: true,
    useMobileStyling: true,
    renderHeader: ModalHeader
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium
    };
};
CreateModal.Inner = ModalInner;
export default connect(mapStateToProps)(CreateModal);
